<!-- <template>
    <section>
        <div id="resourcespage">
            <div class="gsection-title">
                <span class="eyebrow">SAVINGS & RESOURCES: DOWNLOADABLE RESOURCES</span>
                <h2 class="gtitle">Helpful resources to get your patients started on JORNAY PM</h2>
            </div>




            <div id="pharm-instructions" class="resource">
                <div class="photo">
                    <img src="@/assets/img/resources/pharmacy-instructions.png" alt="" />
                </div>
                <div class="cnt">
                    <div class="title">
                        Pharmacy Instructions
                    </div>
                    <div class="cpy">
                        Follow these tips to help with processing the JORNAY PM savings card
                    </div>
                    <div class="buttons">
                        <a class="button" target="_blank" href="/pharmacy-instructions.pdf">Download</a>
                    </div>
                </div>
            </div>




            <div id="review-brochure" class="resource">
                <div class="photo">
                    <img src="@/assets/img/resources/copay-savings.png" alt="" />
                </div>
                <div class="cnt">
                    <div class="title">
                        Learn How Patients Can Save on JORNAY PM
                    </div>
                    <div class="cpy">
                        Help your patients find out if they’re eligible for savings that measure up
                    </div>
                    <div class="buttons">
                        <a class="button" target="_blank" href="/savings-brochure.pdf">Download</a>
                    </div>
                </div>
            </div>








            <div id="dosing-and-information-guide" class="resource">
                <div class="photo">
                    <img src="@/assets/img/resources/dosing-guide.png" alt="" />
                </div>
                <div class="cnt">
                    <div class="title">
                        Dosing and Information Guide
                    </div>
                    <div class="cpy">
                        Provides details on dosing including initiation, titration, and how to achieve successful
                        treatment
                        outcomes
                    </div>
                    <div class="buttons">
                        <a class="button" target="_blank" href="/JORNAY PM Dosing Guide (Digital).pdf">Download</a>
                    </div>
                </div>
            </div>



        <div id="child-patient-profile" class="resource initial">
            <div class="photo">
                <img src="@/assets/img/resources/res01.png" alt="" />
            </div>
            <div class="cnt">
                <div class="title">
                    Why Choose JORNAY PM for Your Pediatric and Adolescent Patients
                </div>
                <div class="buttons">
                    <a class="button" target="_blank"
                        href="/JORNAY PM Peds Detail Aid Leave-Behind Digital (Update Oct 2021).pdf">Read More</a>
                </div>
            </div>
        </div>

        <div id="adult-patient-profile" class="resource">
            <div class="photo">
                <img src="@/assets/img/resources/res02.png" alt="" />
            </div>
            <div class="cnt">
                <div class="title">
                    Why Choose JORNAY PM for Your Adult Patients
                </div>
                <div class="buttons">
                    <a class="button" target="_blank" href="/JORNAY PM Adult Strategy Flyer (Digital).pdf">Read More</a>
                </div>
            </div>
        </div>

        <div id="full-mechanism-of-action" class="resource">
            <div class="photo">
                <img src="@/assets/img/resources/res03.png" alt="" />
            </div>
            <div class="cnt">
                <div class="title">
                    Mechanism of Delivery
                </div>
                <div class="cpy">
                    Visit page 4 to learn more about how JORNAY PM is absorbed
                </div>
                <div class="buttons">
                    <a class="button" target="_blank"
                        href="/JORNAY PM Peds Detail Aid Leave-Behind Digital (Update Oct 2021).pdf">Read More</a>
                </div>
            </div>
        </div>

        <div id="full-pk-profile" class="resource">
            <div class="photo">
                <img src="@/assets/img/resources/res04.png" alt="" />
            </div>
            <div class="cnt">
                <div class="title">
                    Full Pharmacokinetic Profile
                </div>
                <div class="cpy">
                    Visit page 5 to review the pharmacokinetic profile of JORNAY PM
                </div>
                <div class="buttons">
                    <a class="button" target="_blank"
                        href="/JORNAY PM Peds Detail Aid Leave-Behind Digital (Update Oct 2021).pdf">Read More</a>
                </div>
            </div>
        </div>





        <div class="resource">
            <div class="photo">
                <img src="@/assets/img/resources/res07.png" alt="" />
            </div>
            <div class="cnt">
                <div class="title">
                    Long-acting Treatments Available Today That Don’t Contain an Immediate-release Component
                </div>
                <div class="buttons">
                    <a class="button" target="_blank" href="/JORNAY PM Stimulant Flyer - Digital.pdf">Read More</a>
                </div>
            </div>
        </div>
-->



<template>
    <section id="resourcespage">
        <DownloadableResourcesContent />
        <DownloadableResourcesCTA />
    </section>
</template>
<script>
import headers from "../models/headers";
import DownloadableResourcesCTA from "../components/downloadableResources/DownloadableResourcesCTA.vue";
import DownloadableResourcesContent from "../components/downloadableResources/DownloadableResourcesContent.vue";

export default {
    metaInfo: headers.resourcesPage(),
    components: {
        DownloadableResourcesCTA,
        DownloadableResourcesContent
    }
}
</script>